export default {
  highcharts: {
    decimalPoint: ',',
    downloadJPEG: 'Pobierz obraz JPEG',
    downloadPDF: 'Pobierz dokument PDF',
    downloadPNG: 'Pobierz obraz PNG',
    downloadSVG: 'Pobierz obraz SVG',
    exportButtonTitle: 'Eksport',
    forexRate: 'Kurs średni FOREX',
    loading: 'Ładowanie...',
    months: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień',
    ],
    printButtonTitle: 'Drukowanie',
    rangeSelectorFrom: 'Od',
    rangeSelectorTo: 'Do',
    rangeSelectorZoom: 'Przybliżenie',
    rateTypes: {
      ask: 'Najlepsza oferta sprzedaży',
      bid: 'Najlepsza oferta kupna',
      forex: 'Średni kurs na świecie',
    },
    resetZoom: 'Reset',
    resetZoomTitle: 'Reset',
    shortMonths: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
    thousandsSep: ' ',
    weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    wtBestAsk: 'Najlepsza oferta sprzedaży',
    wtBestBid: 'Najlepsza oferta kupna',
  },
  calculator: {
    title: 'Oblicz oszczędność w Walutomacie',
    forBuy: 'za',
    unsupportedPair: 'Aktualnie nie oferujemy kursów dla wybranej pary walutowej.',
    spinnerError: {
      generic: 'Wystąpił problem podczas pobierania danych',
      toManyRequests:
        'Z kalkulatora korzysta teraz bardzo wielu użytkowników. Spróbuj ponownie później lub skontaktuj się z Biurem Obsługi Klienta <a href="https://www.walutomat.pl/kontakt/">https://www.walutomat.pl/kontakt/</a>.',
    },
    commissionWT: 'Prowizja Walutomatu',
    continueButton: 'Kontynuuj wymianę',
    amountText: 'Wartość',
  },
  dashboard: {
    canEditPost: 'Możesz edytować wpis',
    postExists: 'Wpis o takim tytule już istnieje',
    postNotExists: 'Wpis o takim tytule nie istnieje',
    emptyPostTitle: 'Dodaj tytuł wpisu',
    error: 'Coś poszło nie tak :(',
  },
  preactSelect: {
    search: 'Szukaj...',
  },
  continueButton: {
    createAccount: 'Załóż darmowe konto',
    logIn: 'Zaloguj się',
    check: 'Sprawdź',
    checkWhyWorth: 'dlaczego warto',
  },
  calculatorForegin: {
    exchangeRates: 'Kurs wymiany',
    details: 'Szczegóły',
    amountYouSend: 'Kwota, którą wpłacam',
    countryYouSendMoney: 'Kraj, do którego wyślesz pieniądze',
    foreignTransferFee: 'Opłata za przelew zagraniczny',
    foreignTransferType: 'Typ przelewu zagranicznego',
    exchangeAmount: 'Kwota wymiany',
    amountRecipientReceive: 'Kwota, którą otrzyma odbiorca',
    minAmount: 'Kwota wymiany jest zbyt niska.',
    notSellCurrency: 'Sprzedaż waluty jest niedostępna.',
    continueButton: 'Kontynuuj wymianę',
    noCurrenciesSupportedInfo: 'Para walut nieobsługiwana',
    noCountrySupportedInfo: 'Nie obsługujemy wybranej pary w danym kraju.',
    enterAmount: 'Wpisz kwotę',
    commissionWT: 'Prowizja Walutomatu',
    equivalentFee: 'Równowartość',
    commissionAmount: '{{fee_percent}}% całej kwoty',
  },
  timer: {
    update: 'Aktualizacja za:',
    timeUnit: 'sek.',
  },
  networkErrorStatus: {
    slow: 'Problem z pobraniem kursów walut. Wolne połączenie z internetem',
    noNetwork: 'Problem z pobraniem kursów walut. Sprawdź czy masz połączenie z internetem',
    default: 'Wystąpiły problemy techniczne. Skontatuj się z obsługą klienta',
  },
  transferTypes: {
    elixir: {
      header: 'Zwykły',
      subtext: 'Pieniądze dotrą w ciągu 2 - 3 dni roboczych.',
      subtextNoAdditionalCosts:
        'Przy przelewie {{currency}} {{country}} banki zazwyczaj nie pobierają żadnych dodatkowych opłat za przelew.',
      subtextPayoutInPoland:
        'Przy przelewach na terenie Polski banki zazwyczaj nie pobierają żadnych dodatkowych opłat za przelew.',
      subtextSelf: 'Pieniądze dotrą w ciągu 2 - 3 dni roboczych.',
      subtextWarning: 'Uwaga: banki mogą pobrać dodatkową opłatę, która zależy od waluty i kraju docelowego.',
    },
    internal: {
      header: 'Zwykły',
      subtext: 'Pieniądze dotrą najpóźniej następnego dnia roboczego.',
      subtextNoAdditionalCosts:
        'Przy przelewie {{currency}} {{country}} banki zazwyczaj nie pobierają żadnych dodatkowych opłat za przelew.',
      subtextPayoutInPoland:
        'Przy przelewach na terenie Polski banki zazwyczaj nie pobierają żadnych dodatkowych opłat za przelew.',
      subtextSelf: 'Pieniądze dotrą najpóźniej następnego dnia roboczego.',
      subtextWarning: 'Uwaga: banki mogą pobrać dodatkową opłatę, która zależy od waluty i kraju docelowego.',
    },
    internal_bre: {
      header: 'Zwykły',
      subtext: 'Pieniądze dotrą w ciągu 2 - 3 dni roboczych.',
      subtextNoAdditionalCosts:
        'Przy przelewie {{currency}} {{country}} banki zazwyczaj nie pobierają żadnych dodatkowych opłat za przelew.',
      subtextPayoutInPoland:
        'Przy przelewach na terenie Polski banki zazwyczaj nie pobierają żadnych dodatkowych opłat za przelew.',
      subtextSelf: 'Pieniądze dotrą w ciągu 2 - 3 dni roboczych.',
      subtextWarning: 'Uwaga: banki mogą pobrać dodatkową opłatę, która zależy od waluty i kraju docelowego.',
    },
    sepa: {
      header: 'Zwykły',
      subtext: 'Pieniądze dotrą w ciągu 1 - 2 dni roboczych.',
      subtextNoAdditionalCosts:
        'Przy przelewie {{currency}} {{country}} banki zazwyczaj nie pobierają żadnych dodatkowych opłat za przelew.',
      subtextPayoutInPoland:
        'Przy przelewach na terenie Polski banki zazwyczaj nie pobierają żadnych dodatkowych opłat za przelew.',
      subtextSelf: 'Pieniądze dotrą w ciągu 1 - 2 dni roboczych.',
      subtextWarning: 'Uwaga: banki mogą pobrać dodatkową opłatę, która zależy od waluty i kraju docelowego.',
    },
    sorbnet: {
      header: 'Przyśpieszony',
      subtext: 'Pieniądze dotrą najpóźniej następnego dnia roboczego.',
      subtextNoAdditionalCosts:
        'Przy przelewie {{currency}} {{country}} banki zazwyczaj nie pobierają żadnych dodatkowych opłat za przelew.',
      subtextPayoutInPoland:
        'Przy przelewach na terenie Polski banki zazwyczaj nie pobierają żadnych dodatkowych opłat za przelew.',
      subtextSelf: 'Pieniądze dotrą najpóźniej następnego dnia roboczego.',
      subtextWarning: 'Uwaga: banki mogą pobrać dodatkową opłatę, która zależy od waluty i kraju docelowego.',
    },
    spot: {
      header: 'Zwykły',
      subtext: 'Pieniądze dotrą za 2 - 3 dni robocze.',
      subtextNoAdditionalCosts:
        'Przy przelewie {{currency}} {{country}} banki zazwyczaj nie pobierają żadnych dodatkowych opłat za przelew.',
      subtextPayoutInPoland:
        'Przy przelewach na terenie Polski banki zazwyczaj nie pobierają żadnych dodatkowych opłat za przelew.',
      subtextSelf: 'Pieniądze dotrą za 2 - 3 dni robocze.',
      subtextWarning: 'Uwaga: banki mogą pobrać dodatkową opłatę, która zależy od waluty i kraju docelowego.',
    },
    swift_usd: {
      header: 'Zwykły',
      subtext: 'Pieniądze dotrą w ciągu 2 - 3 dni roboczych.',
      subtextNoAdditionalCosts:
        'Przy przelewie {{currency}} {{country}} banki zazwyczaj nie pobierają żadnych dodatkowych opłat za przelew.',
      subtextPayoutInPoland:
        'Przy przelewach na terenie Polski banki zazwyczaj nie pobierają żadnych dodatkowych opłat za przelew.',
      subtextSelf: 'Pieniądze dotrą w ciągu 2 - 3 dni roboczych.',
      subtextWarning: 'Uwaga: banki mogą pobrać dodatkową opłatę, która zależy od waluty i kraju docelowego.',
    },
    today: {
      header: 'Przyśpieszony',
      subtext: 'Pieniądze dotrą najpóźniej następnego dnia roboczego.',
      subtextNoAdditionalCosts:
        'Przy przelewie {{currency}} {{country}} banki zazwyczaj nie pobierają żadnych dodatkowych opłat za przelew.',
      subtextPayoutInPoland:
        'Przy przelewach na terenie Polski banki zazwyczaj nie pobierają żadnych dodatkowych opłat za przelew.',
      subtextSelf: 'Pieniądze dotrą najpóźniej następnego dnia roboczego.',
      subtextWarning: 'Uwaga: banki mogą pobrać dodatkową opłatę, która zależy od waluty i kraju docelowego.',
    },
    today_our: {
      header: 'Przyśpieszony OUR',
      subtext:
        'Pieniądze dotrą najpóźniej następnego dnia roboczego. Gwarancja, że odbiorca otrzyma całą kwotę i banki nie pobiorą po drodze żadnych dodatkowych opłat.',
      subtextNoAdditionalCosts: ' ',
      subtextPayoutInPoland: ' ',
      subtextSelf:
        'Pieniądze dotrą najpóźniej następnego dnia roboczego. Gwarancja, że otrzymasz całą kwotę i banki nie pobiorą po drodze żadnych dodatkowych opłat.',
      subtextWarning: ' ',
    },
    sepa_instant: {
      header: 'Natychmiastowy',
      subtext: 'Pieniądze dotrą w około minutę.',
      subtextNoAdditionalCosts: ' ',
      subtextPayoutInPoland: ' ',
      subtextSelf: 'Pieniądze dotrą w około minutę.',
      subtextWarning: 'Przelew natychmiastowy jest możliwy jedynie do kwoty {{maxAmount}}.',
    },
    local: {
      header: 'Zwykły',
      subtext: 'Pieniądze dotrą najpóźniej następnego dnia roboczego.',
      subtextNoAdditionalCosts: ' ',
      subtextPayoutInPoland: ' ',
      subtextSelf: 'Pieniądze dotrą najpóźniej następnego dnia roboczego.',
      subtextWarning: ' ',
    },
  },
  countries: {
    AD: 'Andora',
    AE: 'Zjednoczone Emiraty Arabskie',
    AF: 'Afganistan',
    AG: 'Antigua i Barbuda',
    AI: 'Anguilla',
    AL: 'Albania',
    AM: 'Armenia',
    AN: 'Antyle Holenderskie',
    AO: 'Angola',
    AQ: 'Antarktyka',
    AR: 'Argentyna',
    AS: 'Samoa Amerykańskie',
    AT: 'Austria',
    AU: 'Australia',
    AW: 'Aruba',
    AX: 'Wyspy Alandzkie',
    AZ: 'Azerbejdżan',
    BA: 'Bośnia i Hercegowina',
    BB: 'Barbados',
    BD: 'Bangladesz',
    BE: 'Belgia',
    BF: 'Burkina Faso',
    BG: 'Bułgaria',
    BH: 'Bahrajn',
    BI: 'Burundi',
    BJ: 'Benin',
    BL: 'Saint Barthélemy',
    BM: 'Bermudy',
    BN: 'Brunei Darussalam',
    BO: 'Boliwia',
    BR: 'Brazylia',
    BS: 'Bahamy',
    BT: 'Bhutan',
    BV: 'Wyspa Bouveta',
    BW: 'Botswana',
    BY: 'Białoruś',
    BZ: 'Belize',
    CA: 'Kanada',
    CC: 'Wyspy Kokosowe',
    CD: 'Demokratyczna Republika Konga',
    CF: 'Republika Środkowej Afryki',
    CG: 'Kongo',
    CH: 'Szwajcaria',
    CI: 'Wybrzeże Kości Słoniowej',
    CK: 'Wyspy Cooka',
    CL: 'Chile',
    CM: 'Kamerun',
    CN: 'Chiny',
    CO: 'Kolumbia',
    CR: 'Kostaryka',
    CU: 'Kuba',
    CV: 'Wyspy Zielonego Przylądka',
    CW: 'Curaçao',
    CX: 'Wyspa Bożego Narodzenia',
    CY: 'Cypr',
    CZ: 'Czechy',
    DE: 'Niemcy',
    DJ: 'Dżibuti',
    DK: 'Dania',
    DM: 'Dominika',
    DO: 'Republika Dominikańska',
    DZ: 'Algieria',
    EC: 'Ekwador',
    EE: 'Estonia',
    EG: 'Egipt',
    EH: 'Sahara Zachodnia',
    ER: 'Erytrea',
    ES: 'Hiszpania',
    ET: 'Etiopia',
    FI: 'Finlandia',
    FJ: 'Fidżi',
    FK: 'Falklandy',
    FM: 'Mikronezja',
    FO: 'Wyspy Owcze',
    FR: 'Francja',
    GA: 'Gabon',
    GB: 'Wielka Brytania',
    GD: 'Grenada',
    GE: 'Gruzja',
    GF: 'Gujana Francuska',
    GG: 'Wyspa Guernsey',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GL: 'Grenlandia',
    GM: 'Gambia',
    GN: 'Gwinea',
    GP: 'Gwadelupa',
    GQ: 'Gwinea Równikowa',
    GR: 'Grecja',
    GS: 'Georgia Południowa i Sandwich Południowy',
    GT: 'Gwatemala',
    GU: 'Guam',
    GW: 'Gwinea Bissau',
    GY: 'Gujana',
    HK: 'Hongkong',
    HM: 'Wyspy Heard i McDonalda',
    HN: 'Honduras',
    HR: 'Chorwacja',
    HT: 'Haiti',
    HU: 'Węgry',
    ID: 'Indonezja',
    IE: 'Irlandia',
    IL: 'Izrael',
    IM: 'Wyspa Man',
    IN: 'Indie',
    IO: 'Terytorium Brytyjskie Oceanu Indyjskiego',
    IQ: 'Irak',
    IR: 'Iran',
    IS: 'Islandia',
    IT: 'Włochy',
    JE: 'Wyspa Jersey',
    JM: 'Jamajka',
    JO: 'Jordania',
    JP: 'Japonia',
    KE: 'Kenia',
    KG: 'Kirgistan',
    KH: 'Kambodża',
    KI: 'Kiribati',
    KM: 'Komory',
    KN: 'Saint Kitts i Nevis',
    KP: 'Korea Północna',
    KR: 'Korea Południowa',
    KW: 'Kuwejt',
    KY: 'Kajmany',
    KZ: 'Kazachstan',
    LA: 'Laos',
    LB: 'Liban',
    LC: 'Saint Lucia',
    LI: 'Liechtenstein',
    LK: 'Sri Lanka',
    LR: 'Liberia',
    LS: 'Lesotho',
    LT: 'Litwa',
    LU: 'Luksemburg',
    LV: 'Łotwa',
    LY: 'Libia',
    MA: 'Maroko',
    MC: 'Monako',
    MD: 'Mołdawia',
    ME: 'Czarnogóra',
    MF: 'Sint Maarten',
    MG: 'Madagaskar',
    MH: 'Wyspy Marshalla',
    MK: 'Macedonia',
    ML: 'Mali',
    MM: 'Birma',
    MN: 'Mongolia',
    MO: 'Makau, Specjalny Region Administracyjny Chin',
    MP: 'Mariany Północne',
    MQ: 'Martynika',
    MR: 'Mauretania',
    MS: 'Montserrat',
    MT: 'Malta',
    MU: 'Mauritius',
    MV: 'Malediwy',
    MW: 'Malawi',
    MX: 'Meksyk',
    MY: 'Malezja',
    MZ: 'Mozambik',
    NA: 'Namibia',
    NC: 'Nowa Kaledonia',
    NE: 'Niger',
    NF: 'Wyspa Norfolk',
    NG: 'Nigeria',
    NI: 'Nikaragua',
    NL: 'Holandia',
    NO: 'Norwegia',
    NP: 'Nepal',
    NR: 'Nauru',
    NU: 'Niue',
    NZ: 'Nowa Zelandia',
    OM: 'Oman',
    PA: 'Panama',
    PE: 'Peru',
    PF: 'Polinezja Francuska',
    PG: 'Papua Nowa Gwinea',
    PH: 'Filipiny',
    PK: 'Pakistan',
    PL: 'Polska',
    PM: 'Saint-Pierre i Miquelon',
    PN: 'Pitcairn',
    PR: 'Portoryko',
    PS: 'Palestyna',
    PT: 'Portugalia',
    PW: 'Palau',
    PY: 'Paragwaj',
    QA: 'Katar',
    RE: 'Reunion',
    RO: 'Rumunia',
    RS: 'Serbia',
    RU: 'Rosja',
    RW: 'Rwanda',
    SA: 'Arabia Saudyjska',
    SB: 'Wyspy Salomona',
    SC: 'Seszele',
    SD: 'Sudan',
    SE: 'Szwecja',
    SG: 'Singapur',
    SH: 'Wyspa Świętej Heleny',
    SI: 'Słowenia',
    SJ: 'Svalbard i Jan Mayen',
    SK: 'Słowacja',
    SL: 'Sierra Leone',
    SM: 'San Marino',
    SN: 'Senegal',
    SO: 'Somalia',
    SR: 'Surinam',
    ST: 'Wyspy Świętego Tomasza i Książęca',
    SV: 'Salwador',
    SY: 'Syria',
    SZ: 'Suazi',
    TC: 'Turks i Caicos',
    TD: 'Czad',
    TF: 'Francuskie Terytoria Południowe',
    TG: 'Togo',
    TH: 'Tajlandia',
    TJ: 'Tadżykistan',
    TK: 'Tokelau',
    TL: 'Timor Wschodni',
    TM: 'Turkmenistan',
    TN: 'Tunezja',
    TO: 'Tonga',
    TR: 'Turcja',
    TT: 'Trynidad i Tobago',
    TV: 'Tuvalu',
    TW: 'Tajwan',
    TZ: 'Tanzania',
    UA: 'Ukraina',
    UG: 'Uganda',
    UM: 'Dalekie Wyspy Mniejsze Stanów Zjednoczonych',
    US: 'Stany Zjednoczone',
    UY: 'Urugwaj',
    UZ: 'Uzbekistan',
    VA: 'Watykan',
    VC: 'Saint Vincent i Grenadyny',
    VE: 'Wenezuela',
    VG: 'Brytyjskie Wyspy Dziewicze',
    VI: 'Wyspy Dziewicze Stanów Zjednoczonych',
    VN: 'Wietnam',
    VU: 'Vanuatu',
    WF: 'Wallis i Futuna',
    WS: 'Samoa',
    XK: 'Kosowo',
    YE: 'Jemen',
    YT: 'Majotta',
    ZA: 'Republika Południowej Afryki',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
  },
  currencies: {
    AED: 'Dirham ZEA',
    ARS: 'Peso argentyńskie',
    AUD: 'Dolar australijski',
    BDT: 'Taka bengalska',
    BGN: 'Lew bułgarski',
    BRL: 'Real brazylijski',
    CAD: 'Dolar kanadyjski',
    CHF: 'Frank szwajcarski',
    CLP: 'Peso chilijskie',
    CNY: 'Juan chiński',
    COP: 'Peso kolumbijskie',
    CZK: 'Korona czeska',
    DKK: 'Korona duńska',
    EGP: 'Funt egipski',
    EUR: 'Euro',
    FJD: 'Dolar fidżi',
    GBP: 'Funt brytyjski',
    GHS: 'Cedi ghańskie',
    HKD: 'Dolar hongkoński',
    HRK: 'Kuna chorwacka',
    HUF: 'Forint węgierski',
    ILS: 'Nowy szekel izraelski',
    INR: 'Rupia indyjska',
    JOD: 'Dinar jordański',
    JPY: 'Jen japoński',
    KWD: 'Dinar kuwejcki',
    LSL: 'Loti lesotyjskie',
    MAD: 'Dirham marokański',
    MXN: 'Peso meksykańskie',
    NOK: 'Korona norweska',
    NPR: 'Rupia nepalska',
    NZD: 'Dolar nowozelandzki',
    OMR: 'Rial omański',
    PEN: 'Sol peruwiański',
    PGK: 'Kina papuańska',
    PLN: 'Polski złoty',
    RON: 'Leja rumuńska',
    RUB: 'Rubel rosyjski',
    SAR: 'Rial saudyjski',
    SEK: 'Korona szwedzka',
    SGD: 'Dolar singapurski',
    SZL: 'Lilangeni',
    THB: 'Bat tajlandzki',
    TRY: 'Lira turecka',
    USD: 'Dolar amerykański',
    UYU: 'Peso urugwajskie',
    WST: 'Tala samoańska',
    ZAR: 'Rand południowoafrykański',
  },
  widgetCalculator: {
    title: 'Sprawdź kursy i{{nbsp}}wymień walutę w{{nbsp}}Walutomacie – szybko i{{nbsp}}korzystnie.',
    actualRate: 'Aktualny kurs',
    buySelect: 'Kupuję',
    sellSelect: 'Sprzedaję',
    buttonText: 'Wymień',
    exchangeAmountSellLabel: 'Otrzymasz',
    exchangeAmountBuyLabel: 'Wpłać',
    commission: 'Prowizja promocyjna ({{commission}}%)',
  },
  formValidation: {
    emptyField: 'Pole nie może być puste',
    requiredField: 'Pole jest wymagane',
    requireAllFields: 'Wszystkie pola muszą być uzupełnione',
    passwordToShort: 'Hasło musi mieć 8 znaków',
    emailNotValid: 'Pole musi zawierać poprawny email',
    emailReserved: 'Adres e-mail jest już zajęty',
    emailUnregistered: 'Nie znaleźliśmy Twojego adresu e-mail w bazie naszych Klientów.',
    markField: 'Zaznacz co najmniej jeden z checkboxów',
    serverUnknownError: 'Błąd komunikacji z serwerem',
    invalidCharacters: 'Pole zawiera niepoprawne znaki',
    phoneNotValid: 'Numer telefonu jest niepoprawny',
    checkBoxBelow: 'Zaznacz proszę pole poniżej, aby wysłać wiadomość',
    promocodeInvalid: 'Niepoprawny kod promocyjny',
    newsletterAlreadySubscribed: 'Ten adres e-mail jest już zapisany do newslettera.',
  },
  cardTests: {
    emailUnregistered:
      'Nie znaleźliśmy Twojego adresu e-mail w bazie naszych Klientów. <a class="error-link" href="{{href}}">Załóż darmowe konto</a> i zapisz się na testy karty Walutomatu.',
    emailAlreadyUsed: 'Ten adres e-mail jest już w naszej bazie zapisów na testy.',
  },
  password: {
    show: 'pokaż',
    hide: 'ukryj',
  },
  howItWorks: {
    showButton: 'Zobacz więcej',
    hideButton: 'Zobacz mniej',
  },
}
